<ng-template [ngIf]="isVerificandoConsegna">
  <app-loading></app-loading>
</ng-template>
<p-steps [model]="pagineValidaConsegna" [readonly]="true" [activeIndex]="activeIndex" >  </p-steps> 
   <div class="d-flex mt-1 ">
    <ng-container [ngSwitch]="activeIndex">
      <ng-container *ngSwitchCase="0">
        <form [formGroup]="verificaRETForm">
          <div class="grid formgrid p-fluid ">
            <div class="field col-12 flex justify-content-start align-items-center mt-2 highlight-checkbox">
              <p-checkbox 
                formControlName="selectAll" 
                binary="true" 
                inputId="selectAllCheckbox" 
                (onChange)="toggleAllFieldsFormRET()">
              </p-checkbox>
              <label for="selectAllCheckbox" class="ml-2 mb-0" >
                SELEZIONA/DESELEZIONA TUTTI
              </label>
            </div>
            <div class="field col-6 flex align-items-center mt-2">
              <p-checkbox formControlName="firma"  binary="true"  inputId="checkboxFirma" > </p-checkbox>
              <label for="checkboxFirma" class="ml-1 mb-0" style="font-size: 11px;">E' presente la firma del progettista ed è coerente con il frontespizio</label>
            </div>
           
            <div class="field col-6 flex align-items-center mt-2">
              <p-checkbox formControlName="premessa"  binary="true"  inputId="checkboxPremessa" > </p-checkbox>
              <label for="checkboxPremessa" class="ml-1 mb-0" style="font-size: 11px;">Il comune, il lotto, il CUIN ed il CIG sono correttamente riportati nella premessa</label>
            </div>
            <div class="field col-6 flex align-items-center  mt-2">
              <p-checkbox formControlName="sedi"  binary="true"   inputId="checkboxSedi" > </p-checkbox>
              <label for="checkboxSedi" class="ml-1 mb-0" style="font-size: 11px;">I dati anagrafici delle sedi scolastiche riportati nella TABELLA 1 sono corretti</label>
            </div>
            <div class="field col-6 flex align-items-center mt-2">
              <p-checkbox formControlName="quesito169"  binary="true"   inputId="checkboxQuesito169" > </p-checkbox>
              <label for="checkboxQuesito169" class="ml-1 mb-0" style="font-size: 10px;">In caso di cambio della tipologia, è riportata la frase indicata nel quesito 169</label>
            </div>
            <div class="field col-6 flex align-items-center">
              <p-checkbox formControlName="dettagliFisici"  binary="true"   inputId="checkboxDettagliFisici" > </p-checkbox>
              <label for="checkboxDettagliFisici" class="ml-1 mb-0" style="font-size: 11px;">I dati riportati nella TABELLA 2 sono coerenti con quelli indicati nella TABELLA 1</label>
            </div>
            <div class="field col-6 flex align-items-center">
              <p-checkbox formControlName="dettagliLogici"  binary="true"   inputId="checkboxDettagliLogici" > </p-checkbox>
              <label for="checkboxDettagliLogici" class="ml-1 mb-0" style="font-size: 11px;">L'IP indicato è coerente con quanto riportato sul verbale di attivazione</label>
            </div>
            <div class="field col-6 flex align-items-center">
              <p-checkbox formControlName="dettagliParametriOfferta"  binary="true"   inputId="checkboxDettagliParametriOfferta" > </p-checkbox>
              <label for="checkboxDettagliParametriOfferta" class="ml-1 mb-0" style="font-size: 11px;">I dati dei parametri di offerta presenti nella TABELLA 1 sono coerenti con il verbale di attivazione</label>
            </div>
            <div class="field col-6 flex align-items-center">
              <p-checkbox formControlName="dettaglioCollegamentoReteAccesso"  binary="true"   inputId="checkboxDettaglioCollegamentoReteAccesso" > </p-checkbox>
              <label for="checkboxDettaglioCollegamentoReteAccesso" class="ml-1 mb-0" style="font-size: 11px;">I dati presenti nella TABELLA 6 sono corretti</label>
            </div>

           
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>

            <div class="field col-12">
              <label for="noteRET" style="font-size: 11px;">Note</label>
              <span class="p-input-icon-left">
                <i class="pi pi-info-circle"></i>
                <textarea id="noteRET" rows="3" [autoResize]="true" formControlName="noteRET" pInputTextarea></textarea>
              </span>
            </div>
            
          </div>
        </form>
      </ng-container>
      <ng-container *ngSwitchCase="1">
        <form [formGroup]="verificaPSIForm">
          <div class="grid formgrid p-fluid">
            <div class="field col-12 flex justify-content-start align-items-center mt-2 highlight-checkbox">
              <p-checkbox 
                formControlName="selectAll" 
                binary="true" 
                inputId="selectAllCheckbox" 
                (onChange)="toggleAllFieldsFormPSI()">
              </p-checkbox>
              <label for="selectAllCheckbox" class="ml-2 mb-0" >
                SELEZIONA/DESELEZIONA TUTTI
              </label>
            </div>
            <div class="field col-12 flex align-items-center mt-2">
              <p-checkbox formControlName="planimetria"  binary="true"   inputId="checkboxPlanimetria" > </p-checkbox>
              <label for="checkboxPlanimetria" class="ml-1 mb-0" style="font-size: 11px;">E' presente la planimetria della scuola o è indicata la posizione della CPE ed è presente una sua foto</label>
            </div>
            
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>

            <div class="field col-12">
              <label for="notePSI" style="font-size: 11px;">Note</label>
              <span class="p-input-icon-left">
                <i class="pi pi-info-circle"></i>
                <textarea id="notePSI" rows="3" [autoResize]="true" formControlName="notePSI" pInputTextarea></textarea>
              </span>
            </div>
          </div>
        </form>
      </ng-container> 
      <ng-container *ngSwitchCase="2">
        <form [formGroup]="verificaSUBIRUForm">
          <div class="grid formgrid p-fluid">
            <div class="field col-12 flex justify-content-start align-items-center mt-2 highlight-checkbox">
              <p-checkbox 
                formControlName="selectAll" 
                binary="true" 
                inputId="selectAllCheckbox" 
                (onChange)="toggleAllFieldsFormSUBIRU()">
              </p-checkbox>
              <label for="selectAllCheckbox" class="ml-2 mb-0" >
                SELEZIONA/DESELEZIONA TUTTI
              </label>
            </div>
            <div class="field col-6 flex align-items-center mt-2">
              <p-checkbox formControlName="annoCessione"  binary="true"   inputId="checkboxAnnoCessione" > </p-checkbox>
              <label for="checkboxAnnoCessione" class="ml-1 mb-0" style="font-size: 11px;">L'anno di <b>cessione</b> <i> è corretto</i></label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>
            <div class="field col-6 flex align-items-center mt-2">
              <p-checkbox formControlName="attestazioneA"  binary="true"   inputId="checkboxAttestazioneA" > </p-checkbox>
              <label for="checkboxAttestazioneA" class="ml-1 mb-0" style="font-size: 11px;">E' presente ed è corretta l'<b>ATTESTAZIONE AL RIPARTITORE A</b></label>
            </div>
            <div class="field col-6 flex align-items-center mt-2">
              <p-checkbox formControlName="attestazioneZ"  binary="true"   inputId="checkboxAttestazioneZ" > </p-checkbox>
              <label for="checkboxAttestazioneZ" class="ml-1 mb-0" style="font-size: 11px;">E' presente ed è corretta l'<b>ATTESTAZIONE AL RIPARTITORE Z</b></label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>

            <div class="field col-6 flex align-items-center mt-2">
              <p-checkbox formControlName="centrale"  binary="true"   inputId="checkboxCentrale" > </p-checkbox>
              <label for="checkboxCentrale" class="ml-1 mb-0" style="font-size: 11px;">La <b>centrale</b> è coerente con quella indicata nella documentazione</label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>

            <div class="field col-12">
              <label for="noteSUBIRU" style="font-size: 11px;">Note</label>
              <span class="p-input-icon-left">
                <i class="pi pi-info-circle"></i>
                <textarea id="noteSUBIRU" rows="3" [autoResize]="true" formControlName="noteSUBIRU" pInputTextarea></textarea>
              </span>
            </div>
          </div>
        </form>
      </ng-container> 
      <ng-container *ngSwitchCase="3">
        <form [formGroup]="verificaNT9Form">
          <div class="grid formgrid p-fluid">
            <div class="field col-12 flex justify-content-start align-items-center mt-2 highlight-checkbox">
              <p-checkbox 
                formControlName="selectAll" 
                binary="true" 
                inputId="selectAllCheckbox" 
                (onChange)="toggleAllFieldsFormNT9()">
              </p-checkbox>
              <label for="selectAllCheckbox" class="ml-2 mb-0" >
                SELEZIONA/DESELEZIONA TUTTI
              </label>
            </div>
            <div class="field col-6 flex align-items-center mt-2">
              <p-checkbox formControlName="shp"  binary="true"   inputId="checkboxSHP" > </p-checkbox>
              <label for="checkboxSHP" class="ml-1 mb-0" style="font-size: 11px;">I file <b>SHAPE</b> sono correttamente compilati</label>
            </div>
            <div class="field col-6 flex align-items-center mt-2">
              <p-checkbox formControlName="csv"  binary="true"   inputId="checkboxCSV" > </p-checkbox>
              <label for="checkboxCSV" class="ml-1 mb-0" style="font-size: 11px;">I file <b>CSV</b> sono correttamente compilati</label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>
            <div class="field col-12 flex align-items-center mt-2">
              <p-checkbox formControlName="coerenzaConPacchetto"  binary="true"   inputId="checkboxCoerenzaPacchetto" > </p-checkbox>
              <label for="checkboxCoerenzaPacchetto" class="ml-1 mb-0" style="font-size: 11px;">I dati contenuti negli shape e nei csv sono coerenti con quanto indicato nel pacchetto AB</label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>
            
            <div class="field col-12">
              <label for="noteNT9" style="font-size: 11px;">Note</label>
              <span class="p-input-icon-left">
                <i class="pi pi-info-circle"></i>
                <textarea id="noteNT9" rows="3" [autoResize]="true" formControlName="noteNT9" pInputTextarea></textarea>
              </span>
            </div>
          </div>
        </form>
      </ng-container> 
    </ng-container>
   </div>

    <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
    <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
       <p-button icon="pi pi-arrow-left" class="p-button-text mr-2" (click)="activeIndex = activeIndex - 1" [disabled]="activeIndex === 0 "></p-button>
        <p-button icon="pi pi-arrow-right" class="p-button-text mr-1" (click)="changePage()" [disabled]="checkNextStep()"></p-button>
        <p-button  icon="pi pi-check" label="Conferma" class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isVerificandoConsegna"></p-button>
    </div>
    <p-toast />
    <p-confirmDialog /> 